import { render, staticRenderFns } from "./AssignPermissionBtn.vue?vue&type=template&id=19480617&scoped=true"
import script from "./AssignPermissionBtn.vue?vue&type=script&lang=js"
export * from "./AssignPermissionBtn.vue?vue&type=script&lang=js"
import style0 from "./AssignPermissionBtn.vue?vue&type=style&index=0&id=19480617&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19480617",
  null
  
)

export default component.exports